import React, { useContext, useEffect, useState } from "react";
import { ApiContext } from ".";

export const DataContext = React.createContext(null);

const { Provider } = DataContext;
export const DataProvider = ({ ...props }) => {
    // providers
    const {
        getImpostazioniAsync,
    } = useContext(ApiContext);


    const [isInitialLoading, setIsInitialLoading] = useState(false);
    const [impostazioni, setImpostazioni] = useState(null);

    const initializeData = async () => {
        setIsInitialLoading(true);
        const impostazioniResponse = await getImpostazioniAsync();
        impostazioniResponse.data && setImpostazioni(impostazioniResponse.data);
        setIsInitialLoading(false);
    }

    useEffect(() => {
        initializeData();
    }, []);

    return (
        <Provider value={{
            isInitialLoading,
            impostazioni,
        }}>
            {props.children}
        </Provider>
    );
}